import styled from './Button.module.scss'

import { ButtonHTMLAttributes, FC, memo, useMemo } from 'react'

const buttonSizes = {
  s: 's',
  m: 'm',
  l: 'l',
} as const

const buttonThemes = {
  primary: 'primary',
  success: 'success',
  error: 'error',
  neutral: 'neutral',
  clean: 'clean',
} as const

type ButtonSize = ObjectValues<typeof buttonSizes>
type ButtonTheme = ObjectValues<typeof buttonThemes>

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  onClick?: () => void
  size?: ButtonSize
  theme?: ButtonTheme
  className?: string
  children?: React.ReactNode
}

const Button: FC<ButtonProps> = memo((props) => {
  const {
    children,
    onClick,
    size = 'm',
    theme = 'primary',
    className,
    ...rest
  } = props

  const ButtonClasses = useMemo(() => {
    const classes = [styled.Button]
    switch (size) {
      case 's':
        classes.push(styled['size_s'])
        break
      case 'm':
        classes.push(styled['size_m'])
        break
      case 'l':
        classes.push(styled['size_l'])
        break
      default:
        classes.push(styled['size_m'])
    }
    switch (theme) {
      case 'primary':
        classes.push(styled['PrimaryTheme'])
        break
      case 'success':
        classes.push(styled['SuccessTheme'])
        break
      case 'error':
        classes.push(styled['ErrorTheme'])
        break
      case 'neutral':
        classes.push(styled['NeutralTheme'])
        break
      case 'clean':
        classes.push(styled['CleanTheme'])
        break
      default:
        classes.push(styled['PrimaryTheme'])
    }

    if (className) {
      classes.push(className)
    }

    return classes.join(' ')
  }, [size, theme, className])

  return (
    <button className={ButtonClasses} type="button" onClick={onClick} {...rest}>
      {children}
    </button>
  )
})

export default Button
